export const UWM_INIT_MARKET_LOCALE = 'UWM_INIT_MARKET_LOCALE';
export const UWM_MODULE_LOADED = 'UWM_MODULE_LOADED';
export const UWM_MODULE_INITIALIZATION_ERROR = 'UWM_MODULE_INITIALIZATION_ERROR';
export const UWM_MODULE_BACK_BUTTON_CLICK = 'UWM_MODULE_BACK_BUTTON_CLICK';
export const UWM_MODULE_DATA_RECEIVED_SUCCESS = 'UWM_MODULE_DATA_RECEIVED_SUCCESS';
export const UWM_MODULE_SCROLL = 'UWM_MODULE_SCROLL';
export const UWM_AMPLITUDE_TRACKING = 'UWM_AMPLITUDE_TRACKING';
export const UWM_MODULE_SHOW_MENU = 'UWM_MODULE_SHOW_MENU';
export const UWM_MODULE_HIDE_MENU = 'UWM_MODULE_HIDE_MENU';
export const UWM_MODULE_GET_EXTERNAL_LINKS = 'UWM_MODULE_GET_EXTERNAL_LINKS';
export const UWM_MODULE_REFETCH_DATA_REQUEST = 'UWM_MODULE_REFETCH_DATA_REQUEST';
export const UWM_REFRESH_BADGES_DATA = 'UWM_REFRESH_BADGES_DATA';
export const UWM_INIT_EXTERNAL_LINKS = 'UWM_INIT_EXTERNAL_LINKS';
